<template>
    <div style="display: flex;justify-content:center;align-items:center;">
        <div class="dingding-icon" :class="auditType? 'checked': ''" title="钉钉审批" @click="changeChnl(true)" v-if="bizType == 'dingding'">
            <i class="icon iconfont icon-dingding" style="font-size: 46px"></i>
        </div>
        <div class="dingding-icon" :class="auditType? 'checked': ''" title="飞书审批" @click="changeChnl(true)" v-else>
            <i class="icon iconfont icon-feishu" style="font-size: 46px"></i>
        </div>
        <div class="swb-logo-icon" :class="!auditType? 'checked': ''" title="商维宝审批" @click="changeChnl(false)">
            <img v-resc-url="'/app/image/logo/swb-white.png'"/>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox } from '../../app.vues'

export default {
    name: 'swb-audit-type',
    desc: '审批方式',
    props: {
        bizType: {
            type: String,
            default: 'dingding'
        },
    },
    data: function () {
        return {
            auditType: true
        }
    },
    created: function () {
    },
    methods: {
        changeChnl: function (auditType) {
            this.auditType = auditType;
        },
        getDlgResult: function () {
            let result = {
                type: 'info',
            };
            if(Utils.isNoB(this.auditType)) {
                result.type = 'warn';
                result.message = '请选择审批方式';
            }
            result.data = Utils.isTrue(this.auditType)
            return result;
        }
    }
}
</script>
<style>
.dingding-icon.checked .icon {
    color: #0c64eb;
}

.swb-logo-icon {
    width: 46px;
    height: 46px;
    background: #606266;
    text-align: center;
    border-radius: 50%;
    padding: 10px;
    margin-left: 30px;
    cursor: pointer;
}

.swb-logo-icon.checked {
    background: #0c64eb;
}

.swb-logo-icon img {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/compo/oaAudit/AuditType.vue